import React from 'react';
import {
  Body,
  Card,
  Grid,
  Heading
} from '@walmart-web/livingdesign-components';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';
import { Link } from 'react-router-dom';
import { ISSUE_CATEGORY } from '../../../constants/common';
import { useAppSelector } from '../../../redux/hooks.ts';
import { ihutSelectors } from '../../../redux/slices/ihut.ts';

const SupportCenterResources = () => {
  const { t } = useTranslation('ihut');
  const activity = useAppSelector(ihutSelectors.selectSelectedActivity);

  return (
    <Grid className={styles.supportResources}>
      <Grid className={styles.textContainer}>
        <Heading size="small">{t('supportCenter.note')}</Heading>
        <Body size="large" UNSAFE_className={styles.preLine}>
          {t('supportCenter.body')}
        </Body>
      </Grid>

      <Link
        to={{
          pathname: '/contact-us',
          state: {
            activityId: activity?.ihutProjectId,
            issueCategory: ISSUE_CATEGORY.ACTIVITY
          }
        }}
        style={{ textDecoration: 'none' }}
      >
        <Card className={styles.cardItem}>
          <Body size="medium" weight={700}>
            {t('supportCenter.createTicket')}
          </Body>
        </Card>
      </Link>
    </Grid>
  );
};

export default SupportCenterResources;
